import type { Table as DataTableInstance } from "@tanstack/react-table";

import TableFunctions from "./TableToolbar";
import type { WpxTableFunctions } from "./types/dataTable.types";

import type { useQueryFilterType } from "@/hooks/query/useQueryParams";
import type { ExtendedColumnDef } from "@/interfaces/globals";

interface WpxTableToolbarControlsProps<TData, TValue> {
  columns: ExtendedColumnDef<TData, TValue>[];
  data: TData[];
  filterOperation: useQueryFilterType;
  functions: WpxTableFunctions<TData, TValue> | undefined;
  hasColumnReordered: boolean;
  hasWritePermission: boolean;
  hide?: boolean;
  resetColumnOrder: () => void;
  table: DataTableInstance<TData>;
}

/**
 * Independent WPX table toolbar controls for search, export, columns, and actions.
 *
 * @param {WpxTableToolbarControlsProps<TData, TValue>} props - Toolbar controls props.
 * @returns {React.JSX.Element} Rendered toolbar controls.
 */
const WpxTableToolbarControls = <TData, TValue>(
  props: WpxTableToolbarControlsProps<TData, TValue>,
): React.JSX.Element => {
  return <TableFunctions {...props} />;
};

export default WpxTableToolbarControls;
export type { WpxTableToolbarControlsProps };
